import * as types from '../mutation-types'
import { API, message } from '../../api'
import { RECORD_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: {
        shareId: '',
        shareData: {},
        shareChanged: false,
        shareFormData: {},
        shareSeletedListData: [],
        shareNewFormData: {},
        showShareChangePop: false,
        showShareSelectPop: false,
    },
    getters: {},
    mutations: {
        [types.DETAIL_SHARED_SHOW](state, shareData) {

            state.shareId = shareData.code;
            console.log('types.DETAIL_SHARED_SHOW----0', shareData, state.shareId);

            API.getShareData(shareData, function (data) {
                console.log("types.DETAIL_SHARED_SHOW------", data);
                // for test
                // data = {
                //     "type":4,
                //     "list":[
                //         // {"id":176284,"uid":10002,"f_name":"Elvira\u5206\u4eab222","sex":1,"location":"{\"province\":\"\u5317\u4eac\u5e02\",\"city\":\"\u5317\u4eac\u5e02\",\"name\":\"\u4e1c\u57ce\u533a\",\"latitude\":116.42188,\"longtude\":39.938576}","birthday":936806400,"f_status":1,"f_time":157240387560904,"f_group":4093,"createtime":1572307548,"tg_1":5,"tg_2":9,"tg_3":0,"tg_4":0,"dz_1":3,"dz_2":9,"dz_3":0,"dz_4":0,"reminder":0,"day_lunar":730,"day_solar":909,"strong":2,"situation":5,"real_time":936805724,"zwzs":0,"unknown":1,"hb":0,"nunpan":0,"pipan":0,"shareid":176283,"glance_time":1572307548,"bz_sz":"5_3|9_9|0_0|0_0","share":"muhuo_0d47744b61e3c85a97d6f004055fd1cf_176284","share2":"muhuo_6493d9a801e839fa521bcbf090a55de8_176284"}
                //     ],
                //     "new": {
                //         "sex": 1,
                //                     "birthday": 594567000,
                //                     "unknown": 0,
                //                     "location": "",
                //                     "zwzs": 1,
                //                     "shareid": 123911,
                //                     "f_name": "匿名"
                //     }
                // };

                state.shareData = data;
                // 渲染八字数据
                switch(data.type){
                    // 0 点开自己的分享，1：自己存在当前八字（源相同）
                    case 0:
                    case 1:
                        AppFate.$store.state.detail.hideBottomBar = false;
                        AppFate.$store.dispatch('detail/initDetail', data.list[0]);
                        AppFate.$store.dispatch('group/initGroupData');
                        AppFate.$store.dispatch('detail/updateDetailGlanceTime', data.list[0]);
                        break;
                    // 2 自动创建了（客户端提示保存）
                    case 2:
                        AppFate.$store.state.detail.hideBottomBar = false;
                        // 渲染并提示修改名字和分组
                        AppFate.$store.dispatch('detail/initDetail', data.list[0]);
                        AppFate.$store.dispatch('group/initGroupData');
                        AppFate.$store.dispatch('detail/updateDetailGlanceTime', data.list[0]);
                        AppFate.$store.dispatch('share/initDetailShareSavePop');
                        AppFate.$toast('此八字已自动保存到八字库');
                        break;
                    // 3 多列表选择，可以另存为 list 的数据为自己的数据，new的数据为另存为调用接口add的数据
                    case 3:
                        AppFate.$store.state.detail.hideBottomBar = true;
                        AppFate.$store.dispatch('detail/initDetail', data.list[0]);
                        AppFate.$store.dispatch('share/initDetailShareSelectPop');
                        break;
                    // 4 不自动保存的，编辑按钮改为保存按钮
                    case 4:
                        AppFate.$store.state.detail.hideBottomBar = true;
                        AppFate.$store.dispatch('detail/initDetail', data.new);
                        AppFate.$store.dispatch('group/initGroupData');
                        break;
                    default:
                        break;
                }
            }, function (data) {
                AppFate.$toast(message[data.status_code]);
                AppFate.$router.replace('/record');
            })
        },
        [types.DETAIL_SHARED_UPDATE_SAVE](state) {
            console.log('types.DETAIL_SHARED_UPDATE_SAVE---', state.shareData)
            if(state.shareData.list.length > 0){
                AppFate.$store.dispatch('share/initDetailShareSelectPop');
            }else{
                state.showShareChangePop = true;
                state.shareFormData = state.shareData.new;
            }
        },
        [types.DETAIL_SHARED_CHANGE_NAME_GROUP](state, params) {
            if(state.shareFormData.shareid) {
                // 另存为新八字
                var newParams = Object.assign({}, state.shareFormData);
                newParams.f_group = newParams.f_group ? newParams.f_group : 0;
    
                API.addPaiPan(newParams, function (data) {
                    // 执行UI回调
                    if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                    AppFate.$toast("保存成功");
                    AppFate.$store.dispatch('detail/resetData');
                    AppFate.$store.dispatch('share/resetData');

                    // 另存为成功后更新命盘数据并跳转至命盘页
                    AppFate.$store.dispatch('detail/initDetail', data);
                    AppFate.$router.replace('/detail/record/' + data.id);

                    // 更新列表数据
                    AppFate.$store.dispatch('record/updateRecordListData', data);
                    // 更新分组数据
                    var groupData = AppFate.$store.state.group.groupData;
                    var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                    AppFate.$store.dispatch('group/updateGroupListData', recordData);
                    // 处理过滤列表数据
                    AppFate.$store.dispatch('record/updateRecordFilterList');
                });
            }else{
                // 提交修改八字名字和分组
                var detailData = AppFate.$store.state.detail;
                var updateParams = {
                    id: detailData.personInfo.id,
                    f_name: state.shareFormData.f_name,
                    f_group: state.shareFormData.f_group
                };
    
                API.updatePaiPan(updateParams, function(data){
                    // 执行UI回调
                    if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                    AppFate.$toast("修改成功");
                    AppFate.$store.dispatch('detail/resetData');
                    AppFate.$store.dispatch('share/resetData');
                    // 修改成功后更新命盘数据并跳转至命盘页
                    AppFate.$store.dispatch('detail/initDetail', data);
                    AppFate.$router.replace('/detail/record/' + data.id);
                    AppFate.$store.dispatch('share/resetData');
                });
            }
        },
        [types.DETAIL_SHARED_INIT_SAVE_POP](state) {
            state.showShareChangePop = true;
            var groupData = AppFate.$store.state.group;
            console.log('types.DETAIL_SHARE_INIT_SAVE_POP----', groupData)
            state.shareFormData['f_name'] = state.shareData.list[0].f_name;
            state.shareFormData['f_group'] = groupData.choosedGroup['id'];
            state.shareFormData['group'] = groupData.choosedGroup['f_name'];
        },
        [types.DETAIL_SHARED_UPDATE_SAVE_POP](state, data) {
            state.shareChanged = true;
            state.shareFormData.group = data.f_name;
            state.shareFormData.f_group = data.id;
        },
        [types.DETAIL_SHARED_INIT_SELECT_POP](state) {
            state.showShareSelectPop = true;
            state.shareSeletedListData = state.shareData.list;
            state.shareNewFormData = state.shareData.new;
        },
        [types.DETAIL_SHARED_RESET_DATA](state) {
            state.shareId = '';
            state.shareData = {};
            state.shareChanged = false;
            state.shareFormData = {};
            state.shareSeletedListData = [];
            state.shareNewFormData = {};
        }
    },
    actions: {
        showSharedDetail({ commit }, shareData) {
            commit(types.DETAIL_SHARED_SHOW, shareData);
        },
        updateShareSave({ commit }) {
            commit(types.DETAIL_SHARED_UPDATE_SAVE);
        },
        changeSharedNameGroup({ commit }, params) {
            commit(types.DETAIL_SHARED_CHANGE_NAME_GROUP, params);
        },
        initDetailShareSavePop({ commit }) {
            commit(types.DETAIL_SHARED_INIT_SAVE_POP);
        },
        updateDetailShareSavePop({ commit }, data) {
            commit(types.DETAIL_SHARED_UPDATE_SAVE_POP, data)
        },
        initDetailShareSelectPop({ commit }) {
            commit(types.DETAIL_SHARED_INIT_SELECT_POP);
        },
        resetData({ commit }) {
            commit(types.DETAIL_SHARED_RESET_DATA)
        }
    }
}